export const customStyles = {
    statusFilter: {
        container: (provided) => ({
            display: "inline-block",
            position: "relative",
            width: "100%",
            minHeight: "45px",
            ...provided
        }),
        control: (provided, state) => ({
            ...provided,
            minHeight: "45px",
            borderColor: "#DCE0E4",
            boxShadow: state.isFocused ? 0 : 0,

            borderRadius: "1px",
            "&:hover": {
                borderWidth: "1px",
                borderColor: "#DCE0E4"
            }
        }),
        option: (provided, state) => ({
            ...provided,
            fontWeight: 500,
            color: state.isSelected ? "#fff" : "#CC9C58",
            background: state.isSelected ? "#CC9C58" : "#fff",
            fontSize: "1rem",
            fontFamily: "PublicSans",
            textAlign: "center",
            "&:hover": {
                color: "#fff",
                background: "#e2b97d"
            }
        }),
        placeholder: (provided) => ({
            ...provided,
            textAlign: "left",
            width: "100%",
            fontSize: "1rem",
            color: "#a5a6a7"
        }),
        singleValue: (provided) => ({
            ...provided,
            textAlign: "left",
            width: "100%" // Ensures single selected value remains centered
        }),
        input: (provided) => ({
            ...provided,
            textAlign: "left",
            fontSize: "1rem",
            color: "black"
        })
    },
    emailFilter: {
        container: (provided) => ({
            display: "inline-block",
            position: "relative",
            width: "100%",
            minHeight: "45px",
            ...provided
        }),
        control: (provided, state) => ({
            ...provided,
            minHeight: "45px",
            borderColor: "#DCE0E4",
            boxShadow: state.isFocused ? 0 : 0,

            borderRadius: "1px",
            "&:hover": {
                borderWidth: "1px",
                borderColor: "#DCE0E4"
            }
        }),
        option: (provided, state) => ({
            ...provided,
            fontWeight: 500,
            color: state.isSelected ? "#fff" : "#CC9C58",
            background: state.isSelected ? "#fff" : "#fff",
            fontSize: "1rem",
            fontFamily: "PublicSans",
            textAlign: "center",
            "&:hover": {
                color: "#fff",
                background: "#fff"
            }
        }),
        placeholder: (provided) => ({
            ...provided,
            textAlign: "left",
            width: "100%",
            fontSize: "1rem",
            color: "#a5a6a7"
        }),
        singleValue: (provided) => ({
            ...provided,
            textAlign: "left",
            width: "100%" // Ensures single selected value remains centered
        }),
        input: (provided) => ({
            ...provided,
            textAlign: "left",
            fontSize: "1rem",
            color: "black"
        })
        // multiValue: (provided) => ({
        //     ...provided,
        //     backgroundColor: "#CC9C58",
        //     color: "#fff",
        //     border: "1px solid #DCE0E4"
        // }),
        // multiValueLabel: (provided) => ({
        //     ...provided,
        //     color: "#fff",
        //     border: "1px solid #DCE0E4"
        // }),
        // multiValueRemove: (provided) => ({
        //     ...provided,
        //     color: "#fff",
        //     border: "1px solid #DCE0E4",
        //     ":hover": {
        //         backgroundColor: "#A47B3C",
        //         color: "#fff"
        //     }
        // })
    }
};
